import "./Legal.module.css";
import Header from "@/reusable_sections/Header";
import TermsPolicies from "./sections/Policies";
import Footer from "@/reusable_sections/Footer";
export default function LegalPage() {
  return <div>
      <Header />
      <TermsPolicies />
      <Footer />
    </div>;
}